import { Article } from "../narrationConstants";

export const SET_USER = 'SET_USER';
export const SIGN_OUT = 'SIGN_OUT';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const NEED_VERIFICATION = 'NEED_VERIFICATION';
export const SET_SUCCESS = 'SET_SUCCESS';
export const CREATE_ANON = 'CREATE_ANON';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_PLAYLIST = 'SET_PLAYLIST';

export interface User {
    firstName: string;
    email: string;
    id: string;
    isAnonymous: boolean;
    created: any;
}

export interface AuthState {
    user: User | null;
    authenticated: boolean;
    loading: boolean;
    error: string;
    needVerification: boolean;
    success: string;
    anonymous : boolean;
    token: string
    playList: Array<Article>
}

export interface SignUpData {
    firstName: string;
    email: string;
    password: string;
}

export interface SignInData {
    email: string;
    password: string;
}

// Actions
interface SetUserAction {
    type: typeof SET_USER;
    payload: User;
}

interface SetAuthToken {
    type: typeof SET_TOKEN;
    payload: string;
}

interface CreateAnonymousUserAction {
    type: typeof CREATE_ANON;
    payload: User;
}

interface SetLoadingAction {
    type: typeof SET_LOADING;
    payload: boolean;
}

interface SignOutAction {
    type: typeof SIGN_OUT;
}

interface SetErrorAction {
    type: typeof SET_ERROR;
    payload: string;
}

interface NeedVerificationAction {
    type: typeof NEED_VERIFICATION;
}

interface SetSuccessAction {
    type: typeof SET_SUCCESS;
    payload: string;
}

interface SetPlayListAction {
    type: typeof SET_PLAYLIST;
    payload: Array<Article>;
}

export type AuthAction = SetUserAction | SetPlayListAction | SetAuthToken | SetLoadingAction | SignOutAction | SetErrorAction | NeedVerificationAction | SetSuccessAction | CreateAnonymousUserAction;

